import { useCallback, useEffect, useRef, useState } from "react";
import { useWebSocketContext } from "../contexts/WebSocketProvider";

export default function useMarkGunFaulty() {
  const { send, isConnected } = useWebSocketContext(); // Removed 'connect' if not using the retry logic

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const mountedRef = useRef(true);

  const markGunFaulty = useCallback(
    async ({ station_id, gun_id, is_faulty, message }) => {
      if (!mountedRef.current) return;

      setIsLoading(true);
      setError("");

      try {
        if (!isConnected) {
          throw new Error("WebSocket is not connected");
        }

        const request = {
          type: "cms_mark_gun_faulty",
          station_id,  // Top level
          gun_id,      // Top level
          is_faulty,   // Top level
          message,     // Top level
        };

        const response = await send("cms_mark_gun_faulty", request);
        return { success: true, response };
      } catch (err) {
        setError(err.message);
        return { success: false, error: err.message };
      } finally {
        if (mountedRef.current) setIsLoading(false);
      }
    },
    [isConnected, send]
  );

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  return {
    markGunFaulty, // Fixed name
    isLoading,
    error,
  };
}